import styled from "styled-components";
import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import Raven from "raven-js";

import { Helmet } from "react-helmet";

import auth from "../../Auth/auth";

import {
  Navbar,
  FooterComponent,
} from "../index";
import { onPhone, onSmallScreen, onSmallDesktop } from "../Elements";

import GLOBAL_CONSTANTS from "../../constants/config";
import Popover from "./popover";
import heroImageDefault from "../images/vts-specs-girl.png";
import heroLogoBox from "../images/vts-logo-box.png";

const Container = styled.div`
  max-width: 1440px;
  // padding: 64px 32px;
  margin: 0 auto;

  ${onPhone} {
    // padding: 32px 16px;
  }
  ${onSmallDesktop} {
    max-width: 1100px;
  }
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${onPhone} {
    flex-direction: column;
  }
  ${onSmallScreen} {
    flex-direction: column;
  }
`;


const CardsContainer = styled(Flex)`
  justify-content: space-between;
  flex-direction: column;
`;

const GroupContainer = styled(Flex)`
  justify-content: start;
  max-width: 1200px;
  margin: 2rem auto;
  width: 100%;
  text-align: center;
  border-radius: 24px;
  flex-direction: column;
  border: 2px solid #f1f5f8;
  background: white;
  box-shadow: 1px 1px 20px 1px rgb(0 0 0 / 8%);
  padding: 2.5rem 2rem;
  ${onPhone} {
    margin: 20px;
    width: 90%;
    padding: 2rem 1.5rem;
  }
  ${onSmallScreen} {
    margin: 20px;
    width: 90%;
  }
`;

const GroupText = styled.div`
  font-size: 30px;
  font-family: "poppins-bold";
  padding: 2rem 0;
  color: #f5821e;
`;

const OfferingsWrapper = styled.div`
  width: 100%;
`;

const OfferingsRow = styled.div`
  width: 95%;
  margin: 2rem auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;

  ${onPhone} {
    width: 100%;
    margin: 1.5rem auto;
  }
`;

const OfferingCard = styled.div`
  position: relative;
  background: ${(props) => props.background || "#e9f2fb"};
  border: 2px solid ${(props) => props.borderColor || "#c5d7e6"};
  border-radius: 26px;
  padding: 3rem 1.75rem 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 12px 30px rgb(40 71 89 / 12%);
  height: 100%;
  text-align: left;
`;

const PriceBadge = styled.div`
  position: absolute;
  top: -18px;
  left: 24px;
  background: #4a5861;
  color: #ffffff;
  font-weight: 700;
  padding: 0.3rem 1.5rem;
  border-radius: 999px;
  font-size: 20px;
  letter-spacing: 0.5px;
`;

const OfferingTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #1f2d38;
`;

const OfferingImage = styled.img`
  width: 100%;
  border-radius: 14px;
  border: 4px solid #ffffff;
  box-shadow: 0 6px 18px rgb(0 0 0 / 12%);
`;

const OfferingList = styled.ul`
  padding-left: 1.2rem;
  margin: 0;
  color: #1f2d38;
  font-size: 16px;
  line-height: 1.45;
  li {
    margin-bottom: 0.35rem;
  }
`;

const OfferingCTAButton = styled.a`
  margin-top: auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.85rem 1.5rem;
  border-radius: 16px;
  background: #f5821e;
  color: #ffffff;
  font-weight: 700;
  text-decoration: none;
  letter-spacing: 0.5px;
  box-shadow: 0 10px 18px rgb(245 130 30 / 45%);
`;

const CTAInfoCard = styled.div`
  background: ${(props) => props.background || "#ffe7bb"};
  border: 2px solid ${(props) => props.borderColor || "#f2c986"};
  border-radius: 20px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  text-align: center;
  box-shadow: 0 8px 18px rgb(0 0 0 / 10%);
`;

const CTAInfoTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #384145;
`;

const CTAInfoButton = styled.a`
  text-decoration: none;
  font-weight: 700;
  color: white;
  background: #f5821e;
  padding: 0.7rem 1.8rem;
  border-radius: 14px;
  letter-spacing: 0.5px;
  width: 100%;
  max-width: 200px;
  box-shadow: 0 8px 16px rgb(245 130 30 / 40%);
`;


const HeroSection = styled.div`
  background: linear-gradient(180deg, #f7fbfd 0%, #ffffff 100%);
  padding: 4rem 2rem 3rem;
  border-bottom: 1px solid #e4eef3;
`;

const HeroContent = styled(Container)`
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 2rem;
  align-items: center;

  ${onPhone} {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 3rem;
  }
  ${onSmallScreen} {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 3rem;
  }
`;

const HeroText = styled.div`
  color: #1f343e;
`;

const HeroTitle = styled.div`
  font-size: 75px;
  font-family: "poppins-bold";
  line-height: 1.05;
  text-align: center;
  margin-bottom: 1.25rem;
  color: #3cbda4;

  ${onPhone} {
    font-size: 42px;
  }
`;


const HeroBody = styled.div`
  font-size: 25px;
  line-height: 1.4;
  text-align: center;
  color: #2f4149;
  max-width: 720px;

  ${onPhone} {
    font-size: 22px;
    margin: 0 auto;
  }
`;


const HeroButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 28px;
  background: #f5821e;
  color: #ffffff;
  font-family: "poppins-bold";
  font-size: 22px;
  border-radius: 999px;
  text-decoration: none;
  margin-top: 0;
  box-shadow: 0 8px 20px rgb(0 0 0 / 12%);

  &:hover {
    box-shadow: 0 10px 26px rgb(0 0 0 / 18%);
  }
`;

const HeroVisual = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
`;

const HeroFrame = styled.div`
  position: absolute;
  inset: 10% 0 10% 0;
  margin: auto;
  max-width: 360px;
  max-height: 360px;
  border-radius: 12px;
  opacity: 0.15;
  background: radial-gradient(circle at 20% 20%, #f5821e 0, transparent 25%),
    radial-gradient(circle at 80% 20%, #5b98ff 0, transparent 25%),
    radial-gradient(circle at 20% 80%, #3cbda4 0, transparent 25%),
    radial-gradient(circle at 80% 80%, #2f4149 0, transparent 25%);
  z-index: 0;
`;

const HeroLogoBox = styled.img`
  position: absolute;
  bottom: 120px;
  right: 20%;
  width: clamp(160px, 40vw, 360px);
  z-index: 1;
  opacity: 0.9;
`;

const HeroImage = styled.img`
  position: relative;
  max-height: 420px;
  width: auto;
  right: 15%;
  object-fit: contain;
  z-index: 2;
`;

const HeroVisualContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  z-index: 2;
`;

export default function Program(props) {
  let [redirectToReferer, setRedirectToReferer] = useState(false);
  let [websiteURLs, setWebsiteURLs] = useState({
    program_page_videos: {},
    typeform_urls: {},
  });
  const [showPopover, setShowPopover] = useState(false);
  const heroImage = props.heroImageSrc || heroImageDefault;
  const heroImageAlt = props.heroImageAlt || "Student engaged in VTS";
  const aboutUsPath = props.publicPage ? "/public/aboutus" : "/aboutus";
  const topTierOfferings = [
    {
      id: "student-curriculum",
      price: "$40",
      title: "VTS Student Curriculum",
      image: require("../images/daily-image.png"),
      bullets: ["All 400+ PK-12 Student Curriculum Images", "32-image Grade-level Sets (curated by Philip Yenawine)"],
      href: "https://www.watershed-ed.org/schools/visual-teaching-strategies/vts-pk-12-student-image-curriculum-1",
      ctaText: "Purchase",
    },
    {
      id: "facilitator-training",
      price: "$40",
      title: "VTS Facilitator Training",
      image: require("../images/open-resources.png"),
      bullets: ["All VTS Training Modules, FAQs, Discussion Videos", "All VTS Training Resources (w/Philip Yenawine)"],
      href: "https://www.watershed-ed.org/schools/visual-teaching-strategies/vts-basics-pk-12-professional-learning-module",
      ctaText: "Purchase",
    },
    {
      id: "all-access-intro",
      price: "$60",
      title: "Comprehensive Package",
      image: require("../images/starter-pack.png"),
      bullets: ["All 400+ PK-12 Student Curriculum Images", "All VTS Training Resources (w/Philip Yenawine)"],
      href: "https://www.watershed-ed.org/schools/visual-teaching-strategies/all-access-package",
      ctaText: "Purchase",
    },
  ];
  const midTierOfferings = [
    {
      id: "all-access",
      price: "$20",
      title: "Weekly Image Email",
      image: require("../images/offerings-r2-c1.1.png"),
      bullets: [
        "One Image Every Week",
        "In Your (Child’s) Inbox",
      ],
      href: "https://form.typeform.com/to/E4oP9cNM",
      ctaText: "Sign Up",
    },
    {
      id: "curriculum-only",
      price: "$20",
      title: "Classroom Starter Kit",
      image: require("../images/offerings-r2-c1.3.png"),
      bullets: [
        "Get Started With VTS Today",
        "2 Hours of PD, 3-5 Pilot Lessons",
      ],
      href: "https://www.watershed-ed.org/schools/visual-teaching-strategies/vts-basics-pk-12-professional-learning-module-starter-pack",
      ctaText: "Purchase",
    },
    {
      id: "teacher-pd",
      price: "$20",
      title: "Weekly Practice Email",
      image: require("../images/offerings-r2-c3.2.jpg"),
      bullets: [
        "Sustain Your VTS Practice",
        "Sent Weekly, Sep-May",
      ],
      href: "https://form.typeform.com/to/GIj1yuq4",
      ctaText: "Sign Up",
    },
  ];
  const ctaInfoCards = [
    {
      id: "cta-all-access",
      title: "Mission and Model",
      buttonText: "LEARN MORE",
      href: aboutUsPath,
      background: "#ffe4bc",
      borderColor: "#f7c78d",
      newTab: false,
    },
    {
      id: "cta-curriculum",
      title: "Community Access Partners",
      buttonText: "LEARN MORE",
      href: "https://form.typeform.com/to/aqfl5XtG",
      background: "#ffe9c9",
      borderColor: "#f7d6a4",
      anchorId: "community-access",
      newTab: true,
    },
    {
      id: "cta-teacher-pd",
      title: "Global Access Partners",
      buttonText: "LEARN MORE",
      href: "https://form.typeform.com/to/FsUyYmgN",
      background: "#ffe1ba",
      borderColor: "#f7ca94",
      anchorId: "global-access",
      newTab: true,
    },
  ];

  useEffect(() => {
    fetch(GLOBAL_CONSTANTS.WEBSITE_URLS)
      .then((res) => res.json())
      .then((result) => {
        setWebsiteURLs(result);
      });
    setTimeout(() => {
      setShowPopover(false); // Disabling the pop up as false on 23.01.24 as per Nick's Request. Can enable when it is required
    }, 5000);
  }, []);

  let login = (provider) => {
    return async () => {
      const subscribe = false;

      try {
        await auth.authenticate(provider, subscribe);
        setRedirectToReferer(true);
      } catch (err) {
        if (err && err.error && err.error.code === "cancelled") {
        }

        Raven.captureException(err);
        console.error("Error", err);
      }
    };
  };

  if (redirectToReferer) {
    return <Redirect to="/" />;
  }


  return (
    <div
      className="App"
      style={{
        background: "white",
        fontFamily: "poppins-regular",
        color: "#515151",
      }}
    >
    
      <Helmet
        title="VTS K12 School program | Visual Thinking Strategies curriculum and professional development"
        meta={[
        {
          name: "title",
          content: "VTS K12 School program",
        },
        {
          name: "description",
          content: "Visual Thinking Strategies curriculum and professional development"
        }
        ]}
      />
      <Navbar login={login} {...props} />
      {/* <div style={{maxWidth: "1200px", margin: "3rem auto 1rem"}}>
        <div style={{fontSize: "40px", fontFamily: "poppins-bold"}}>Teacher and School Subscriptions</div>
        <div style={{fontSize: "25px"}}>Enrich every classroom with rich discussion and responsive instruction through Visual Thinking Strategies.</div>
      </div> */}
      { showPopover ? <Popover /> : null }
      <HeroSection>
        <HeroContent>
          <HeroText>
            <HeroTitle>Visual Thinking Strategies</HeroTitle>
            {/* <HeroSubtitleRow>
              <HeroSubtitle>PK-12 curriculum and training</HeroSubtitle>
            </HeroSubtitleRow> */}
            <HeroBody>
              PK-12 curriculum and training equips students and educators everywhere with a research-backed teaching and learning method - fostering critical thinking, communication, and social-emotional skills - preparing students{" "}
              for success in school and beyond.
              <br/>
            </HeroBody>
            
          </HeroText>
          <HeroVisual>
            <HeroFrame />
            <HeroLogoBox src={heroLogoBox} alt="VTS frame motif" />
            <HeroVisualContent>
              <HeroImage src={heroImage} alt={heroImageAlt} />
              <HeroButton
                href={props.heroButtonHref || "https://watershed-site-documents.s3.amazonaws.com/Watershed-VTS-Program-Model.pdf"}
                target="_blank"
                rel={props.heroButtonHref ? "noreferrer" : undefined}
              >
                Program Overview
              </HeroButton>
            </HeroVisualContent>
          </HeroVisual>
        </HeroContent>
      </HeroSection>
      {/* cards */}
      <CardsContainer>
        <GroupContainer id="vts-offerings">
          <GroupText>VTS Offerings</GroupText>
          <OfferingsWrapper>
            <OfferingsRow>
              {topTierOfferings.map((card) => (
                <OfferingCard key={card.id} background="#e7f0fa">
                  <PriceBadge>{card.price}</PriceBadge>
                  <OfferingTitle>{card.title}</OfferingTitle>
                  <OfferingImage src={card.image} alt={`${card.title} visual`} />
                  <OfferingList>
                    {card.bullets.map((bullet, index) => (
                      <li key={`${card.id}-${index}`}>{bullet}</li>
                    ))}
                  </OfferingList>
                  {card.ctaText && (
                    <OfferingCTAButton href={card.href} target="_blank" rel="noreferrer">
                      {card.ctaText}
                    </OfferingCTAButton>
                  )}
                </OfferingCard>
              ))}
            </OfferingsRow>
            <OfferingsRow>
              {midTierOfferings.map((card) => (
                <OfferingCard key={card.id} background="#ffffff" borderColor="#e0e6ed">
                  <PriceBadge>{card.price}</PriceBadge>
                  <OfferingTitle>{card.title}</OfferingTitle>
                  <OfferingImage src={card.image} alt={`${card.title} collage`} />
                  <OfferingList>
                    {card.bullets.map((bullet, index) => (
                      <li key={`${card.id}-${index}`}>{bullet}</li>
                    ))}
                  </OfferingList>
                  {card.ctaText && (
                    <OfferingCTAButton href={card.href} target="_blank" rel="noreferrer">
                      {card.ctaText}
                    </OfferingCTAButton>
                  )}
                </OfferingCard>
              ))}
            </OfferingsRow>
            <OfferingsRow>
              {ctaInfoCards.map((cta) => (
                <CTAInfoCard
                  key={cta.id}
                  id={cta.anchorId}
                  background={cta.background}
                  borderColor={cta.borderColor}
                >
                  <CTAInfoTitle>{cta.title}</CTAInfoTitle>
                  <CTAInfoButton
                    href={cta.href}
                    target={cta.newTab ? "_blank" : undefined}
                    rel={cta.newTab ? "noreferrer" : undefined}
                  >
                    {cta.buttonText}
                  </CTAInfoButton>
                </CTAInfoCard>
              ))}
            </OfferingsRow>
          </OfferingsWrapper>
        </GroupContainer>
      </CardsContainer>
      
      <FooterComponent {...props} />
    </div>
  );
}
